import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import useIsTitleOrSectionHovered from 'hooks/useIsTitleOrSectionHovered';
import useDesktopNavItems from 'components/nav/shared/data/useDesktopNavItems';
import DesktopNavCategorySectionUI from './DesktopNavCategorySectionUI';
const DesktopNavCategorySection = t0 => {
  const $ = _c(15);
  const {
    categoryId,
    isOpen
  } = t0;
  const categoryNavItems = useDesktopNavItems();
  let t1;
  if ($[0] !== categoryId || $[1] !== categoryNavItems) {
    t1 = categoryNavItems.find(item => item.id === categoryId) || null;
    $[0] = categoryId;
    $[1] = categoryNavItems;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const selectedCategory = t1;
  const {
    selectedItem: selectedSubcategory,
    setIsTitleHovered,
    setIsSectionHovered
  } = useIsTitleOrSectionHovered();
  if (selectedCategory) {
    const t2 = `DesktopNavCategory--${selectedCategory.id}`;
    const t3 = selectedCategory.ctaUrl || selectedCategory.url;
    let t4;
    if ($[3] !== isOpen || $[4] !== selectedCategory.ctaLabel || $[5] !== selectedCategory.customContent || $[6] !== selectedCategory.image || $[7] !== selectedCategory.items || $[8] !== selectedCategory.secondaryItems || $[9] !== selectedSubcategory || $[10] !== setIsSectionHovered || $[11] !== setIsTitleHovered || $[12] !== t2 || $[13] !== t3) {
      t4 = <DesktopNavCategorySectionUI id={t2} items={selectedCategory.items} secondaryItems={selectedCategory.secondaryItems} ctaLabel={selectedCategory.ctaLabel} ctaUrl={t3} image={selectedCategory.image} isOpen={isOpen} selectedSubcategory={selectedSubcategory} setIsSectionHovered={setIsSectionHovered} setIsTitleHovered={setIsTitleHovered} customContent={selectedCategory.customContent} />;
      $[3] = isOpen;
      $[4] = selectedCategory.ctaLabel;
      $[5] = selectedCategory.customContent;
      $[6] = selectedCategory.image;
      $[7] = selectedCategory.items;
      $[8] = selectedCategory.secondaryItems;
      $[9] = selectedSubcategory;
      $[10] = setIsSectionHovered;
      $[11] = setIsTitleHovered;
      $[12] = t2;
      $[13] = t3;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    return t4;
  }
  return null;
};
DesktopNavCategorySection.propTypes = {
  categoryId: PropTypes.string,
  isOpen: PropTypes.bool
};
export default DesktopNavCategorySection;